'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PhysicalBlock = require('./components/PhysicalBlock.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PhysicalBlock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-physical-block/lib/index.js
// module id = 1007
// module chunks = 1